import React, { Component } from 'react';
import {AuthContext} from "../context/auth";
import {
    Link
} from "react-router-dom";
export default class About extends Component {
    static contextType = AuthContext
    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {}

    }

    render() {
        return (
            <div className="card shadow w100">
                <div className="card-header py-3">
                    <h2 className="m-0 font-weight-bold l"> About </h2>
                </div>
                <div className="card-body">
                    <h5>The admin panel was developed by <a href="https://galaxy4games.com/">Galaxy4Games</a> to manage the game server</h5>

                    <h5  className="pt-4">Setup:</h5>
                    <div>You can change/add in <Link to={"/vars"}>Vars</Link>  AppFaviconUrl, AppLogoUrl, AppTitle</div>

                    <h5  className="pt-4">Company Documentation:</h5>
                    <div><a href="https://docs.galaxy4gm.com">https://docs.galaxy4gm.com</a></div>

                    <h5 className="pt-4">Information: </h5>
                    <div>
                        The project consists of separate HTTP servers and modules.<br/>
                        A service is a part of the application's business logic that can be separated as an independent server. For example: admin panel, commands, leaderboards, player saves, liveOps-events<br/>
                        A module is a library (project) used by one or more services.<br/>
                        Each service and module is a git submodule. They can be shared with partner studios or used in multiple projects/applications.<br/>
                        As a result, we deploy a cluster of servers in kube, or for small projects, in docker containers. <br/>
                        The architecture is built using ASP.net applications, Akka.net, mongoDB, Redis. <br/>
                    </div>

                    <h5 className="pt-4">Files: </h5>
                    <div>
                        Needed to view/edit files and make them publicly available on the internet.
                        Addressables.
                        WebGl builds.
                        Uses AWS S3 storage and CloudFront as CDN;
                    </div>

                    <h5 className="pt-4">Utilities / Vars: </h5>
                    <div>
                        Some settings, so you don’t have to write a separate editor for each one.
                    </div>

                    <h5 className="pt-4">Utilities / UserVars: </h5>
                    <div>
                        <b>This is an important section of this server cluster</b> <br/>
                        We have 2 types of variables. <br/>
                        &emsp; * fully controlled by the client (save in JSON format) <br/>
                        &emsp; * controlled only by the backend (for cheat protection). For example, important in-game currency. <br/>
                        <br/>
                        The player’s save is stored in the users service in MongoDB (BSON).
                        Each variable is a key and a path to a value in the player’s save or profile.
                        Thanks to this, we can:<br/>
                        &emsp;* build projections when querying the database<br/>
                        &emsp;* get a list of player segments (via reflection and BSON document)<br/>
                        &emsp;* use any save format for any business logic of the application<br/>
                    </div>

                    <h5 className="pt-4">Utilities / Versions: </h5>
                    <div>
                        Every change in the admin panel is logged.
                        All settings are collected into a single document with its own Ver.
                        In the dev environment, this happens automatically.
                        In production, you need to run UploadToServer to apply all changes to the cluster servers.
                    </div>

                    <h5 className="pt-4">Users: </h5>
                    <div>
                        Player save management
                    </div>
                    <h5 className="pt-4">Cohorts: </h5>
                    <div>
                        Player segmentation. We use conditions for variables from UserVars.
                        All conditions within one cohort are combined with a logical "AND".
                        In an event/offer, we can select several cohorts that will have access to it. The selected cohorts are combined with a logical "OR".
                    </div>
                    <h5 className="pt-4">Events: </h5>
                    <div>
                        LiveOps system. A separate service. Includes mini-games, offers (bank), notifications. Each will be described later.
                    </div>

                    <h5 className="pt-4">Teams: </h5>
                    <div>
                        ...
                    </div>
                </div>
            </div>
        );
    }
}